import apiClient from './api.service';

const MessageService = {
  // Get messages for a course
  getMessagesByCourse(courseId) {
    return apiClient.get(`/message/byCourse/${courseId}`);
  },

  // Post a message into a course's chat (admin action)
  addCourseMessage(courseId, message) {
    return apiClient.post('/message/admin/add', { course_id: courseId, message });
  }
};

export default MessageService;
